import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { formatDurationFromToday } from '../../../../../utils/svtDateAndTime';
import { PlayBadge, THEMES } from '../../../../PlayBadge/PlayBadge';

const LastChanceBadge = ({ expireDate, live, maxDays }) => {
    const [isVisible, setVisible] = useState(false);

    useEffect(() => {
        if (live || !expireDate) {
            setVisible(false);

            return;
        }

        const now = moment();
        const expire = moment(expireDate);
        const expiresInDays = expire.diff(now, 'days');

        if (now.isAfter(expire) || expiresInDays > maxDays) {
            setVisible(false);
        } else {
            setVisible(true);
        }
    }, [live, expireDate, maxDays]);

    const expireText = formatDurationFromToday(expireDate);

    if (!isVisible) {
        return null;
    }

    return (
        <PlayBadge
            text={`${expireText} kvar`}
            accessibilityText={`Kan ses i ${expireText} till.`}
            theme={THEMES.LAST_CHANCE}
            overlay
        />
    );
};

export default LastChanceBadge;
